import React, { useEffect } from 'react'
import cn from 'classnames'
import { map } from 'lodash'

import { ReactComponent as LoadingIcon } from '../../assets/loading-dark.svg'
import styles from './ReceiptDetails.module.scss'

const SuitesReceiptDetails = ({ className, orderNumber, digitalReceipt, onMount }) => {
  const classNames = cn(styles.receiptDetails, className)
  const loading = digitalReceipt?.loading
  const failed = digitalReceipt?.failed


  useEffect(() => {
    onMount()
  }, [])

  const renderItems = (items) => {
    return map(items, (item) => {
      const name = item.name
      const quantity = item.quantity
      const price = item.price

      return (
          <div className={styles.row} key={item.id}>
          <div className={styles.columnContainer}>
            <div className={styles.column}>
              <span className={styles.quantity}>{quantity}</span>
            </div>
            <div className={styles.column}>
              <span>{name}</span>
              <span className={styles.modifiers}>{item.modifiersString}</span>
            </div>
          </div>
          <span className={styles.price}>{price}</span>
        </div>
      )
    })
  }

  const makeMenuItemsDisplay = (lineItems) =>
    map(lineItems, (items, menuType) => (
      <>
        {renderItems(items)}
      </>
    ))

  if (loading) {
    return <LoadingIcon /> 
  }

  if (failed) {
    return <div>Receipt failed to load</div>
  }

  return (
    <div className={classNames}>
      <div className={styles.header}>
        <div className={styles.title}>{digitalReceipt.header}</div>
        <div className={styles.orderNumber}>{`Order #${orderNumber}`}</div>
        <div className={styles.attendant}>{digitalReceipt?.attendant}</div>
        <div className={styles.subTitle}>Thanks! Enter your email for a copy of your receipt.</div>
      </div>
      <div className={styles.lineItems}>
        {makeMenuItemsDisplay(digitalReceipt?.groupedItems)}
        <div className={styles.divider}></div>
        {renderItems(digitalReceipt.secondaryItems)}
        <div className={styles.divider}></div>
        {renderItems(digitalReceipt.tertiaryItems, {fontWeight: 700})}
      </div>
      <div className={styles.payment}>
        <h3 className={styles.paymentHeader}>Payment</h3>
        <div className={styles.paymentType}>
          <span>{digitalReceipt.payment}</span>
          <span>{digitalReceipt.total}</span>
        </div>
      </div>
    </div>
  )
}

export default SuitesReceiptDetails
